"use client";

import { SwitchProfiles } from "@packages/kids";
import { showModal } from "@packages/ui";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";

export const KidsSwitchProfilesHandler = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (searchParams.get("open_switch_profiles") !== "true") return;

    const params = new URLSearchParams(searchParams.toString());
    params.delete("open_switch_profiles");
    const newUrl = params.size > 0 ? `${pathname}?${params}` : pathname;
    router.replace(newUrl, { scroll: false });

    showModal(SwitchProfiles, {});
  }, [searchParams]);

  return null;
};
